<div style="max-width: 480px; margin: 0 auto; background: #f8f9fa; min-height: 100vh; position: relative;">

  <!-- Header -->
  <header style="display: flex; flex-direction: column; padding: 16px 20px; background: white; box-shadow: 0 2px 4px rgba(0,0,0,0.05); gap: 12px;">
    <div style="display: flex; justify-content: center; align-items: center; padding-bottom: 8px;">
      <img src="assets/img/Logo.svg" alt="Aguacate Wallet" style="height: 40px; width: auto;" />
    </div>
    <div style="display: flex; align-items: center; justify-content: space-between; gap: 12px;">
      <button *ngIf="currentStep > 1" type="button" (click)="backStep()"
        style="display: flex; align-items: center; gap: 4px; background: none; border: none; font-size: 14px; font-weight: 600; color: #333; cursor: pointer; padding: 8px; border-radius: 4px;"
        onmouseover="this.style.background='#f0f0f0'" onmouseout="this.style.background='none'">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
        ATR&Aacute;S
      </button>
      <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 0.5rem; flex: 1;">
        <div style="background-color: #1C593D; color: white; padding: 0.25rem 0.75rem; border-radius: 999px; font-size: 0.875rem; font-weight: 600; white-space: nowrap;">
          Paso {{ currentStep }}/{{ totalSteps }}
        </div>
        <div style="width: 100%; height: 12px; background-color: #b2f0c0; border-radius: 999px; overflow: hidden;">
          <div style="height: 100%; background-color: #1C593D; border-radius: 999px; transition: width 0.3s ease;"
            [style.width.%]="(currentStep / totalSteps) * 100"></div>
        </div>
      </div>
    </div>
  </header>

  <!-- Horario info -->
  <div style="display: flex; align-items: center; gap: 8px; background: #e3f2fd; border-radius: 0; padding: 10px 20px;">
    <span style="font-size: 16px;">&#9200;</span>
    <span style="font-size: 13px; color: #1565c0; font-weight: 500;">Horario de operacion: <strong>7:00 - 23:00</strong></span>
  </div>

  <!-- Step 1: Beneficiary -->
  <div [style.display]="currentStep === 1 ? 'block' : 'none'" style="padding: 20px;">
    <app-beneficiary-fiat
      #beneficiarioComponent
      (changeStep)="nextStep($event)"
      (beneficiarioOutput)="assignBeneficiario($event)"
      (goBack)="backStep()"></app-beneficiary-fiat>
  </div>

  <!-- Step 2: Calculator -->
  <div [style.display]="currentStep === 2 ? 'block' : 'none'" style="padding: 20px;">
    <app-calculator-fiat-cal
      #calculatorComponent
      (clpCurrencyEmit)="assignClp($event)"
      (vesCurrencyEmit)="assignZelle($event)"
      (changeStep)="nextStep($event)"
      (goBack)="backStep()"
      [ves_buy_rate]="vesSellValue"
      [minLimit]="minLimit"
      [limitSell]="limitFiatSell"
      [rateList]="rateList">
    </app-calculator-fiat-cal>
  </div>

  <!-- Step 3: Summary -->
  <div [style.display]="currentStep === 3 ? 'block' : 'none'" style="padding: 20px;">
    <app-summary-order-fiat
      [clpCurrency]="clpCurrency"
      [vesCurrency]="vesCurrency"
      [ves_clp_tax]="vesSellValue"
      [beneficiario]="beneficiario"
      [valorCambioId]="valorCambioId"
      (goBack)="backStep()"></app-summary-order-fiat>
  </div>

</div>
